import { render, staticRenderFns } from "./OwnershipTypesFilter.vue?vue&type=template&id=456913a4"
import script from "./OwnershipTypesFilter.vue?vue&type=script&lang=js"
export * from "./OwnershipTypesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports